export const categories = [
  { id: 'tshirts', name: 'T-shirts', icon: 'ri-t-shirt-line' },
  { id: 'chemises', name: 'Chemises', icon: 'ri-shirt-line' },
  { id: 'polo-golf', name: 'Polo Golf', icon: 'ri-shirt-line' },
  { id: 'polo-simple', name: 'Polo Simple', icon: 'ri-shirt-line' },
  { id: 'ensembles', name: 'Ensembles', icon: 'ri-handbag-line' },
  { id: 'jean-simple', name: 'Jean Simple', icon: 'ri-user-line' },
  { id: 'jean-design', name: 'Jean avec Design', icon: 'ri-user-line' },
  { id: 'pantalon', name: 'Pantalon', icon: 'ri-user-line' },
  { id: 'chaussures', name: 'Chaussures', icon: 'ri-footprint-line' },
  { id: 'telephones', name: 'Téléphones', icon: 'ri-smartphone-line' },
  { id: 'perruques', name: 'Perruques', icon: 'ri-scissors-line' },
  { id: 'costume-croise', name: 'Costume Croisé', icon: 'ri-briefcase-line' },
  { id: 'costume-simple', name: 'Costume Simple', icon: 'ri-briefcase-line' },
  { id: 'sacs-homme', name: 'Sacs Homme', icon: 'ri-briefcase-line' },
  { id: 'sacs-femme', name: 'Sacs Femme', icon: 'ri-handbag-line' },
  { id: 'accessoires', name: 'Accessoires', icon: 'ri-vip-crown-line' }
];

export const initialProducts = [
  {
    id: '1',
    name: 'T-shirt Premium Coton',
    category: 'tshirts',
    price: 15000,
    image: 'https://public.readdy.ai/ai/img_res/875fe4c0aaad47c3c9a02c1f33ac820c.jpg',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    available: true,
    description: 'T-shirt en coton premium, confortable et durable'
  },
  {
    id: '2',
    name: 'Chemise Élégante Blanche',
    category: 'chemises',
    price: 25000,
    image: 'https://readdy.ai/api/search-image?query=elegant%20white%20dress%20shirt%20on%20clean%20white%20background%2C%20crisp%20fabric%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20centered%20composition%2C%20business%20formal%20wear%2C%20pure%20white%20backdrop&width=400&height=500&seq=chemise1&orientation=portrait',
    sizes: ['S', 'M', 'L', 'XL'],
    available: true,
    description: 'Chemise élégante parfaite pour toutes occasions'
  },
  {
    id: '3',
    name: 'Polo Golf Performance',
    category: 'polo-golf',
    price: 20000,
    image: 'https://readdy.ai/api/search-image?query=golf%20polo%20shirt%20on%20clean%20white%20background%2C%20athletic%20performance%20fabric%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20centered%20composition%2C%20sportswear%20style%2C%20pure%20white%20backdrop&width=400&height=500&seq=polo1&orientation=portrait',
    sizes: ['M', 'L', 'XL'],
    available: true,
    description: 'Polo golf haute performance, respirant'
  },
  {
    id: '4',
    name: 'Polo Classique',
    category: 'polo-simple',
    price: 18000,
    image: 'https://readdy.ai/api/search-image?query=classic%20polo%20shirt%20on%20clean%20white%20background%2C%20quality%20cotton%20fabric%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20centered%20composition%2C%20casual%20wear%20style%2C%20pure%20white%20backdrop&width=400&height=500&seq=polo2&orientation=portrait',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    available: true,
    description: 'Polo classique pour un style décontracté'
  },
  {
    id: '5',
    name: 'Ensemble Sportswear',
    category: 'ensembles',
    price: 45000,
    image: 'https://readdy.ai/api/search-image?query=sportswear%20tracksuit%20set%20on%20clean%20white%20background%2C%20athletic%20wear%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20centered%20composition%2C%20modern%20activewear%2C%20pure%20white%20backdrop&width=400&height=500&seq=ensemble1&orientation=portrait',
    sizes: ['M', 'L', 'XL'],
    available: true,
    description: 'Ensemble sportswear confortable et stylé'
  },
  {
    id: '6',
    name: 'Jean Classique Bleu',
    category: 'jean-simple',
    price: 30000,
    image: 'https://readdy.ai/api/search-image?query=classic%20blue%20denim%20jeans%20on%20clean%20white%20background%2C%20quality%20denim%20fabric%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20centered%20composition%2C%20casual%20wear%2C%20pure%20white%20backdrop&width=400&height=500&seq=jean1&orientation=portrait',
    sizes: ['28', '30', '32', '34', '36', '38'],
    available: true,
    description: 'Jean classique en denim de qualité'
  },
  {
    id: '7',
    name: 'Jean Design Déchiré',
    category: 'jean-design',
    price: 35000,
    image: 'https://readdy.ai/api/search-image?query=designer%20ripped%20jeans%20on%20clean%20white%20background%2C%20distressed%20denim%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20centered%20composition%2C%20trendy%20fashion%20style%2C%20pure%20white%20backdrop&width=400&height=500&seq=jean2&orientation=portrait',
    sizes: ['28', '30', '32', '34', '36'],
    available: true,
    description: 'Jean avec design moderne et déchiré'
  },
  {
    id: '8',
    name: 'Pantalon Chino Beige',
    category: 'pantalon',
    price: 28000,
    image: 'https://readdy.ai/api/search-image?query=beige%20chino%20pants%20on%20clean%20white%20background%2C%20quality%20cotton%20fabric%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20centered%20composition%2C%20smart%20casual%20wear%2C%20pure%20white%20backdrop&width=400&height=500&seq=pantalon1&orientation=portrait',
    sizes: ['28', '30', '32', '34', '36', '38'],
    available: true,
    description: 'Pantalon chino élégant et confortable'
  },
  {
    id: '9',
    name: 'Baskets Sport Premium',
    category: 'chaussures',
    price: 40000,
    image: 'https://readdy.ai/api/search-image?query=premium%20sport%20sneakers%20on%20clean%20white%20background%2C%20athletic%20footwear%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20centered%20composition%2C%20modern%20shoe%20design%2C%20pure%20white%20backdrop&width=600&height=400&seq=chaussure1&orientation=landscape',
    sizes: ['39', '40', '41', '42', '43', '44', '45'],
    available: true,
    description: 'Baskets sport de haute qualité'
  },
  {
    id: '10',
    name: 'Smartphone Android Pro',
    category: 'telephones',
    price: 150000,
    image: 'https://readdy.ai/api/search-image?query=modern%20android%20smartphone%20on%20clean%20white%20background%2C%20sleek%20design%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20centered%20composition%2C%20technology%20device%2C%20pure%20white%20backdrop&width=400&height=500&seq=phone1&orientation=portrait',
    sizes: ['Unique'],
    available: true,
    description: 'Smartphone Android dernière génération'
  },
  {
    id: '11',
    name: 'Perruque Naturelle Longue',
    category: 'perruques',
    price: 55000,
    image: 'https://readdy.ai/api/search-image?query=natural%20long%20hair%20wig%20on%20clean%20white%20background%2C%20quality%20synthetic%20hair%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20centered%20composition%2C%20beauty%20product%20style%2C%20pure%20white%20backdrop&width=400&height=500&seq=perruque1&orientation=portrait',
    sizes: ['Unique'],
    available: true,
    description: 'Perruque naturelle de haute qualité'
  },
  {
    id: '12',
    name: 'Costume Croisé Élégant',
    category: 'costume-croise',
    price: 85000,
    image: 'https://readdy.ai/api/search-image?query=elegant%20double-breasted%20suit%20on%20clean%20white%20background%2C%20luxury%20formal%20wear%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20centered%20composition%2C%20business%20attire%2C%20pure%20white%20backdrop&width=400&height=500&seq=costume1&orientation=portrait',
    sizes: ['S', 'M', 'L', 'XL'],
    available: true,
    description: 'Costume croisé pour occasions spéciales'
  },
  {
    id: '13',
    name: 'Costume Simple Noir',
    category: 'costume-simple',
    price: 75000,
    image: 'https://readdy.ai/api/search-image?query=classic%20black%20suit%20on%20clean%20white%20background%2C%20formal%20business%20wear%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20centered%20composition%2C%20elegant%20attire%2C%20pure%20white%20backdrop&width=400&height=500&seq=costume2&orientation=portrait',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    available: true,
    description: 'Costume simple et élégant'
  },
  {
    id: '14',
    name: 'Sac Business Cuir Homme',
    category: 'sacs-homme',
    price: 45000,
    image: 'https://readdy.ai/api/search-image?query=leather%20business%20bag%20for%20men%20on%20clean%20white%20background%2C%20professional%20briefcase%2C%20quality%20leather%20texture%2C%20studio%20lighting%2C%20centered%20composition%2C%20executive%20style%2C%20pure%20white%20backdrop&width=600&height=400&seq=sac1&orientation=landscape',
    sizes: ['Unique'],
    available: true,
    description: 'Sac business en cuir véritable'
  },
  {
    id: '15',
    name: 'Sac à Main Femme Élégant',
    category: 'sacs-femme',
    price: 38000,
    image: 'https://readdy.ai/api/search-image?query=elegant%20womens%20handbag%20on%20clean%20white%20background%2C%20luxury%20fashion%20accessory%2C%20quality%20leather%2C%20studio%20lighting%2C%20centered%20composition%2C%20designer%20style%2C%20pure%20white%20backdrop&width=600&height=400&seq=sac2&orientation=landscape',
    sizes: ['Unique'],
    available: true,
    description: 'Sac à main élégant pour femme'
  },
  {
    id: '16',
    name: 'Montre Classique',
    category: 'accessoires',
    price: 25000,
    image: 'https://readdy.ai/api/search-image?query=classic%20wristwatch%20on%20clean%20white%20background%2C%20elegant%20timepiece%2C%20professional%20product%20photography%2C%20studio%20lighting%2C%20centered%20composition%2C%20luxury%20accessory%2C%20pure%20white%20backdrop&width=500&height=500&seq=accessoire1&orientation=squarish',
    sizes: ['Unique'],
    available: true,
    description: 'Montre classique élégante'
  }
];
